import { Info } from "lucide-react"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/Popover"
import { glossaryTerm, type GlossaryTerm } from "@/lib/glossary"

export function termTitle(term: GlossaryTerm): string {
  return term.fullName ? `${term.term} (${term.fullName})` : term.term
}

// One glossary term's explanation: the summary, how it is counted, an
// example and a note. Shared by the Glossary page and the (i) popups.
export function GlossaryTermBody({ term }: { term: GlossaryTerm }) {
  return (
    <div className="space-y-2 text-sm leading-relaxed">
      <p>{term.summary}</p>
      <ul className="list-disc space-y-1 pl-5">
        {term.points.map((point) => (
          <li key={point}>{point}</li>
        ))}
      </ul>
      {term.example && <p><span className="font-medium">Example:</span> {term.example}</p>}
      {term.note && <p className="rounded-md bg-muted px-3 py-2">{term.note}</p>}
    </div>
  )
}

// The (i) after a number's label: opens that term's glossary entry.
export default function GlossaryInfo({ termId }: { termId: string }) {
  const term = glossaryTerm(termId)

  return (
    <Popover>
      <PopoverTrigger
        aria-label={`What ${term.term} means`}
        className="ml-1 inline-flex align-middle text-muted-foreground hover:text-foreground transition-colors cursor-pointer"
      >
        <Info className="size-3" />
      </PopoverTrigger>
      <PopoverContent className="w-96 space-y-2 text-left font-normal normal-case tracking-normal">
        <div className="text-sm font-semibold">{termTitle(term)}</div>
        <GlossaryTermBody term={term} />
      </PopoverContent>
    </Popover>
  )
}
